export enum StoreEnums {
  stores = 'Store/Stores', // 取得店家資訊清單
  storesV2 = 'v2/Store/Stores', // 新系統：取得店家資訊清單
  storesUnderMyOwn = 'Store/StoresDDL', // 可用店家(只取自己名下的店家)
  storesOnOtherPool = 'Store/OnOtherPoolStoresDDL', // 可用店家(其他店主底下的可用店家)
  add = 'Store/Add', // 新增店家資訊
  update = 'Store/Update', // 更新店家資訊
  disable = 'Store/Disable', // 停用店家資訊
  recordCurrentStore = 'Store/RecordCurrentStore', // 暫存目前點選的店家
  changeStoreGroup = 'Store/ChangeStoreGroup', // 變更店家群組
  updateStoreTimeZone = 'Store/UpdateStoreTimeZone', // 更新店家結帳時區
  getStoreTimeZoneModifyRecord = 'Store/GetStoreTimeZoneModifyRecord', // 取得店家結帳時區修改記錄
  getStoreTimeZone = 'Store/GetStoreTimeZone', // 取得店家當前時區設定
  getAccountTimezones = 'Store/GetAggregatedDistinctTimezonesForStoresOfThisAccount', // 取得此帳號底下所有店家的時區清單
  storeMetricThreshold = 'Store/store-metric-threshold', // 取得/更新店家指標門檻設定
  // 新系統：一次取得此帳號底下所有店家的營運分析與風險警示計數（2026-09-10 契約整併，
  // 原本的 stores-operations-alert 已下架）；timeZoneId 必填，useMockData 為後端假資料開關
  storeOperationsAnalytics = 'v2/Store/operations-analytics'
}
